import React, { FunctionComponent } from 'react';
import { MessageTemplateModal } from '../../molecules/messageTemplateModal';

type Props = {
  className?: string;
  handleModalOpen: () => void;
  handleModalClose: () => void;
  isModalOpen: boolean;
  targetArea: string;
  targetName: string;
  disabled: boolean;
  onApplyTemplate?: (value: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  className,
  handleModalOpen,
  handleModalClose,
  isModalOpen,
  targetArea,
  targetName,
  disabled,
  onApplyTemplate,
}) => {
  return (
    <>
      <button
        type= "button"
        className={className}
        disabled={disabled}
        onClick={handleModalOpen}
      >
        テンプレート
      </button>
      {isModalOpen && (
        <MessageTemplateModal
          targetArea={targetArea}
          editingStatus="send"
          handleModalOpen={handleModalOpen}
          handleModalClose={handleModalClose}
          targetName={targetName}
          onApplyTemplate={onApplyTemplate}
        />
      )}
    </>
  );
};
